<template>
  <div class="container dashboard college-dashboard">
    <div v-if="report === null" class="row">
      <Loader style="width: 100%;" />
    </div>

    <div v-else class="row">
      <div class="col-12">
        <div class="row row-eq-height">
          <div class="col-12 col-md-3">
            <div class="dashboard-card light stat">
              <label>Number of Colleges</label>
              <h2>{{ report.num_colleges_with_students_registered | number }}</h2>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="dashboard-card light stat">
              <label>Student Registrations</label>
              <h2>{{ report.num_students_registered | number }}</h2>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="dashboard-card light stat">
              <label>On Campus Counselors</label>
              <h2>{{ report.num_on_campus_counselors_registered | number }}</h2>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="dashboard-card light stat">
              <label>Off Campus Counselors</label>
              <h2>{{ report.num_off_campus_counselors_registered | number }}</h2>
            </div>
          </div>
        </div>
        <div class="row row-eq-height">
          <div class="col-12 col-lg-5">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Most Used Services
              </h2>
              <table class="table bm-table">
                <tbody>
                  <tr>
                    <td>
                      Individual Sessions
                    </td>
                    <td class="text-right">
                      {{ report.num_individual_sessions_scheduled | number }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Wellbeing Workshops
                    </td>
                    <td class="text-right">
                      {{ report.num_group_sessions_scheduled | number }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      On-Campus Events
                    </td>
                    <td class="text-right">
                      {{ report.num_college_events_scheduled | number }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="report" class="col-12 col-lg-7">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Sessions
              </h2>
              <SessionsByMonth :report="report.appointment_report" />
            </div>
          </div>
          <div class="col-12 col-lg-8">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Counselors By State
              </h2>
              <CounselorsByState />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Counselors By Ethnicity
              </h2>
              <CounselorByEthnicity />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Counselors By Gender
              </h2>
              <CounselorByGender />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Counselors By Specialty
              </h2>
              <CounselorBySpecialty />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Counselors By Specialty
              </h2>
              <CounselorBySpecialtyPercentage />
            </div>
          </div>
          <div class="col-12 col-lg-8">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Students By State
              </h2>
              <StudentsByState />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="dashboard-card">
              <h2 class="mb-4">
                Students By Race/Ethnicity
              </h2>
              <StudentByEthnicity />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12">
        <div class="dashboard-card">
          <h2 class="mb-4">
            Counseling Sessions By State
          </h2>
          <SessionsByState />
        </div>
      </div>
      <div class="col-12 col-lg-12">
        <div class="dashboard-card">
          <h2 class="mb-4">
            Availability Hours By State
          </h2>
          <available-hours-by-state />
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="dashboard-card light stat">
          <label>Average Platform Feedback</label>
          <h2>{{ averageAppFeedback }}</h2>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="dashboard-card light stat">
          <label>Average Counselor Feedback</label>
          <h2>{{ averageCounselorFeedback }}</h2>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="dashboard-card light stat">
          <label>Feedback Comments</label>
          <ul style="overflow-wrap: break-word;">
            <li v-for="(commentSample, index) in feedbackCommentsSample" :key="index">
              <i>"{{ commentSample.answer }}"</i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/Loader.vue';

import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';
import SurveyClient from '@/api/SurveyClient';
import CounselorsByState from './components/CounselorsByState.vue';
import StudentsByState from './components/StudentsByState.vue';
import SessionsByState from './components/SessionsByState.vue';
import SessionsByMonth from './components/SessionsByMonth.vue';

import CounselorByGender from './components/CounselorByGender.vue';
import CounselorBySpecialtyPercentage from './components/CounselorBySpecialtyPercentage.vue';
import CounselorBySpecialty from './components/CounselorBySpecialty.vue';
import StudentByEthnicity from './components/StudentByEthnicity.vue';
import CounselorByEthnicity from './components/CounselorByEthnicity.vue';
import AvailableHoursByState from './components/AvailableHoursByState.vue';

export default {
  name: 'CounselorDashboard',
  components: {
    Loader,
    CounselorsByState,
    StudentsByState,
    StudentByEthnicity,
    CounselorByEthnicity,
    CounselorBySpecialtyPercentage,
    CounselorBySpecialty,
    SessionsByState,
    SessionsByMonth,
    CounselorByGender,
    AvailableHoursByState,
  },
  data() {
    return {
      report: null,
      sessionData: null,
      userClient: new UserClient(this.$http),
      adminClient: new AdminClient(this.$http),
      surveyClient: new SurveyClient(this.$http),

    };
  },
  created() {
    this.adminClient.getAdminSchoolReport().then(res => {
      this.report = res;
    }).catch(() => {
      this.report = {};
    });
  },
  asyncComputed: {
    async averageAppFeedback() {
      const results = await this.surveyClient.getAverageStarRating('student-appt-feedback-app-exp')
      if (results === null) {
        return 'N/A'
      }

      return results.average
    },
    async averageCounselorFeedback() {
      const results = await this.surveyClient.getAverageStarRating('student-appt-feedback-cou-exp')
      if (results === null) {
        return 'N/A'
      }

      return results.average
    },
    async feedbackCommentsSample() {
      const results = await this.surveyClient.getFreeTextResponses('student-appt-feedback-comment', 0, 3)
      if (results === null) {
        return []
      }
      
      return results
    }
  }
};
</script>

<style lang="scss" scoped>
.college-dashboard {
  .stat {
    padding: 25px 30px;

    label {
      @include label;

      display: inline-block;
      color: $green;
      margin-bottom: -5px;
    }

    h2 {
      font-size: 60px;
      margin-top: -5px;
    }
  }
  .row-eq-height {
    .dashboard-card {
      height: calc(100% - 20px);
    }
  }
}

</style>
